<template>
  <div>
    <el-dialog
      :visible.sync="dialog"
      width="950px"
      center
      :before-close="handleClose"
      :close-on-click-modal="false"
      custom-class="my-dialog"
    >
      <div class="pano-header">
        <span class="title">模型素材库</span>
        <div class="select">
          <el-input placeholder="请输入内容" v-model="searchTxt" class="input-with-select">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <div class="upload-block">
          <el-button size="mini" @click="dialogFormVisible=true">上传素材</el-button>
        </div>
      </div>
      <div class="pano-modal-body">
        <div class="title-line">
          <!-- <div class="title-line-left" @click="chooseAll">
            <div class="checkbox-block">
              <div :class="{'checkbox':true,'active':allcheck}">
                <i class="el-icon-check"></i>
              </div>
            </div>
            <div class="all-word">全选</div>
          </div>-->
        </div>
        <div class="list">
          <div class="list-li" v-for="(item,i) in arr" :key="i" @click="choose(item.id)">
            <div class="checkbox-block">
              <div :class="{'checkbox':true,'active':item.check}">
                <i class="el-icon-check"></i>
              </div>
            </div>
            <div class="middle">
              <div class="img-block">
                <img :src="item.icon" />
              </div>
              <div class="li-title">{{item.name}}</div>
            </div>

            <div class="date">{{item.createTime | dateFormat('YY-mm-dd HH:MM')}}</div>
          </div>
        </div>
        <div class="page-block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page.currentPage"
            :page-size="8"
            layout="total, prev, pager, next, jumper"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="模型信息" :visible.sync="dialogFormVisible" custom-class="xming-dialog">
      <el-form>
        <el-form-item label="名称" :label-width="width">
          <el-input v-model="model.name1" autocomplete="off" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="width">
          <el-input v-model="model.beizhu" autocomplete="off" style="width:90%"></el-input>
        </el-form-item>
        <div >
               <el-button
          size="mini"
          @click="upload2">上传缩略图</el-button>
          <img :src="model.src2" height="200" alt="" style="margin-left:20px">
           </div>
             <div style='margin-top:20px'>
               <el-button
          size="mini"
          @click="upload1">上传模型文件</el-button>
           <el-input v-model="model.modelpath" autocomplete="off"  style='width:70%;margin-left:10px' disabled></el-input>
             </div>
        <el-form-item label="模型类型" :label-width="width" style="margin-top:20px">
          <el-select v-model="model.types" placeholder="请选择模型类型">
            <el-option label="obj" value="obj"></el-option>
            <el-option label="fbx" value="fbx"></el-option>
            <el-option label="gltf" value="gltf"></el-option>
            <el-option label="dae" value="dae"></el-option>
            <el-option label="json" value="json"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <input type="file" ref="inputUp1" @change="change1" style="display:none" />
      <input type="file" ref="inputUp2" @change="change2" style="display:none" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
.el-input__inner{
  color: #606266!important;
}
.upload-block span{
  color:#606266!important
}
.el-button--default span{
  color:#606266!important
}
.el-form{
  text-align: left;

}
.el-form button span{
  color:#606266!important
}
.xming-dialog .el-dialog__title {
    color: #303133!important;
}
.xming-dialog .el-form-item__label {
    color: #303133!important;
}
.my-dialog {
   color: black;
  z-index: 10000;
}
.my-dialog.el-dialog--center .el-dialog__body {
  padding: 0 0 10px 0;
}

/* .my-dialog .el-dialog__header {
  padding: 0;
} */

.my-dialog .el-dialog__headerbtn {
  top: 7px;
  right: 7px;
  z-index: 10;
}
.el-pager .number{
 color: black;
}
</style>
<style scoped>
img{
  vertical-align: top!important;
}
.pano-header {
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 20px;
  font-size: 20px;
  border-bottom: 1px solid #e9e9e9;
}

.title {
  margin-right: 20px;
  font-size: 16px;
  font-weight: 700;
  color: black;
}

.select {
  flex: 1 auto;
}

.input-with-select {
  width: 200px;
}

.upload-block {
  font-size: 14px;
}

.pano-model-body {
  position: relative;
  flex: 1 auto;
}

.title-line {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  background-color: #f3f3f3;
  border-bottom: 1px solid #e9e9e9;
}

.title-line-left {
  display: flex;
  align-items: center;
}
.all-word {
  color: black;
}

.checkbox-block {
  margin-right: 10px;
}

.checkbox {
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  color: white !important;
}

.checkbox.active {
  background-color: #427afb;
  border-color: #427afb;
}

.list {
  height: 435px;
}

.list-li {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid #e9e9e9;
}

.middle {
  display: flex;
  flex: 1 auto;
  align-items: center;
}

.img-block {
  width: 30px;
  height: 30px;
  background-color: #ddd;
  cursor: pointer;
}

.img-block img {
  width: 100%;
  height: 100%;
}

.li-title {
  max-width: 500px;

  margin-left: 10px;
  line-height: 30px;
  font-size: 12px;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  color: black;
}

.date {
  font-size: 12px;
  color: #9b9b9b;
}

.page-block {
  display: flex;
  justify-content: center;
}
</style>
<script>
import https from '../https.js'
import md5 from 'js-md5'
import axios from 'axios'
export default {
  name: '',
  props: {
    closeFunc: Function,
    submitFunc: Function
  },
  components: {},

  data() {
    return {
      dialogFormVisible: false, //上传模型框
      type: 3, //模型类型
      dialog: true,
      searchTxt: '',
      allcheck: false,
      page: {
        currentPage: 1,
        total: 0
      },
      chooseArr: [],
      arr: [
        // {
        //   id: "44901c67-81c4-4f30-8fea-c1d0dfc1927b",
        //   fileName: "weixin_code.png",
        //   filePath: "/Attached/2020/6/17/weixin_code.png",
        //   fileFormat: ".png",
        //   hashValue: "2020617135921",
        //   fileSize: 11917,
        //   type: null,
        //   status: 1,
        //   createTime: "2020-06-17T13:59:21.487",
        //   thumbnailUrl: null
        // }
      ],
      model: {
        name1: '',
        beizhu: '',
        src1: './images/model1.png',
        src2: './images/noImg.jpg',
        types: '',
        modelpath: ''
      },

      width: '400'
    }
  },
  created() {},
  mounted() {
    this.init1()
  },
  methods: {
    init() {
      https
        .fetchPost('/api/PhysicalFile/Get', {
          type: this.type,
          pageIndex: this.page.currentPage,
          pageSize: 8
        })
        .then(res => {
          console.log(res.data)
          this.page.total = res.data.count

          for (let i = 0; i < res.data.result.length; i++) {
            res.data.result[i].check = false
          }
          this.arr = res.data.result
        })
    },
    handleCurrentChange(val) {
      this.allcheck = false
      this.chooseArr = []
      this.page.currentPage = val
      this.init1()
    },
    // chooseAll() {
    //   this.allcheck = !this.allcheck;
    //   if (this.allcheck) {
    //     for (let i = 0; i < this.arr.length; i++) {
    //       this.arr[i].check = true;
    //     }
    //     this.chooseArr = this.arr;
    //   } else {
    //     for (let i = 0; i < this.arr.length; i++) {
    //       this.arr[i].check = false;
    //     }
    //     this.chooseArr = [];
    //   }
    // },
    choose(id) {
      this.chooseArr = []
      for (let i = 0; i < this.arr.length; i++) {
        if (this.arr[i].id === id) {
          const isCheck = this.arr[i].check || false
          if (isCheck) {
            this.arr[i].check = false
          } else {
            this.arr[i].check = true
            this.chooseArr.push(this.arr[i])
          }
        } else {
          this.arr[i].check = false
        }
      }
    },
    handleClose(done) {
      this.closeFunc()
    },
    uploadPic(data) {
      console.log(data)
      this.init()
    },
    submit() {
      this.submitFunc(this.chooseArr)
      this.closeFunc()
    },
    //上传模型
    upload1() {
      this.$refs.inputUp1.click()
    },
    upload2() {
      this.$refs.inputUp2.click()
    },
    confirm() {
      if(this.model.name1 == '') {
        this.$message({
          type: 'error',
          message: '名称不能为空!'
        })
      } else if(this.model.modelpath == '') {
        this.$message({
          type: 'error',
          message: '模型不能为空!'
        })
      } else if(this.model.types == '') {
        this.$message({
          type: 'error',
          message: '请选择模型类型!'
        })
      } else{
        https
          .fetchPost('/api/model/AddScene', {
            id: '',
            name: this.model.name1,
            remark: this.model.beizhu,
            path: this.model.modelpath,
            icon: this.model.src2,
            sceneType: this.model.types
          })
          .then(res => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.dialogFormVisible = false
            this.init1()
          })
      }
    },
    init1() {
      https
        .fetchGet('/api/model/GetBaseSceneInfo', {
          pageIndex: this.page.currentPage,
          // fileName:this.searchTxt,
          pageSize: 8
        })
        .then(res => {
          console.log(res)
          this.page.total = res.data.count

          for (let i = 0; i < res.data.result.length; i++) {
            res.data.result[i].check = false
          }
          this.arr = res.data.result
        })
    },
    change1(e) {
      var files = e.target.files
      var file = files[0]
      const fileReader = new FileReader()
      const blobSlice =
          File.prototype.mozSlice ||
          File.prototype.webkitSlice ||
          File.prototype.slice
      const chunkSize = 2097152
      // read in chunks of 2MB
      const chunks = Math.ceil(file.size / chunkSize)
      let currentChunk = 0

      let bir = ''
      const a = this
      const formData = new FormData()
      // formData.append('type', 2)
      formData.append('hashvalue', md5(bir))
      formData.append('file', file)
      fileReader.onload = function(e) {
        console.log('read chunk nr', currentChunk + 1, 'of', chunks)
        bir += e.target.result // append binary string
        currentChunk++
        if (currentChunk < chunks) {
          loadNext()
        } else {
          console.log(md5(bir))

          console.log(formData.get('hashvalue'))
          var options = {
            // 设置axios的参数
            url: '/api/model/UploadModel',
            data: formData,
            method: 'post',
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          axios(options).then(res => {
            console.log(res)
            if (res.data.mes === '成功') {
              a.model.src1 = './images/model2.png'
              a.model.modelpath = 'http://model001.z2ww.com' + res.data.filePath
              a.$message('上传成功')
            }
          })
        }
      }
      function loadNext() {
        var start = currentChunk * chunkSize
        var end =
            start + chunkSize >= file.size
              ? file.size
              : start + chunkSize
        fileReader.readAsBinaryString(blobSlice.call(file, start, end))
      }
      loadNext()
    },
    change2(e) {
      var files = e.target.files
      var file = files[0]
      const fileReader = new FileReader()
      const blobSlice =
          File.prototype.mozSlice ||
          File.prototype.webkitSlice ||
          File.prototype.slice
      const chunkSize = 2097152
      // read in chunks of 2MB
      const chunks = Math.ceil(file.size / chunkSize)
      let currentChunk = 0

      let bir = ''
      const a = this
      const formData = new FormData()
      // formData.append('type', 2)
      formData.append('hashvalue', md5(bir))
      formData.append('file', file)
      fileReader.onload = function(e) {
        console.log('read chunk nr', currentChunk + 1, 'of', chunks)
        bir += e.target.result // append binary string
        currentChunk++
        if (currentChunk < chunks) {
          loadNext()
        } else {
          console.log(md5(bir))

          console.log(formData.get('hashvalue'))
          var options = {
            // 设置axios的参数
            url: '/api/model/UploadModel',
            data: formData,
            method: 'post',
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          axios(options).then(res => {
            console.log(res)
            if (res.data.mes === '成功') {
              a.model.src2 = 'http://model001.z2ww.com' + res.data.filePath
              a.$message('上传成功')
            }
          })
        }
      }
      function loadNext() {
        var start = currentChunk * chunkSize
        var end =
            start + chunkSize >= file.size
              ? file.size
              : start + chunkSize
        fileReader.readAsBinaryString(blobSlice.call(file, start, end))
      }
      loadNext()
    }
  }
}
</script>
